<template>
  <v-container fluid class="region-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-region`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-image-filter-hdr</v-icon>
            Region
          </v-tab>
          <v-tab-item
            :value="'tab-region'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Region</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'regioncode')"
                        v-bind:value="initvalue.regioncode"
                        placeholder="Region Code"
                        persistent-hint
                        single-line hint="Enter the region code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'regionname')"
                        v-bind:value="initvalue.regionname"
                        placeholder="Region Name"
                        persistent-hint
                        single-line hint="Enter the region name">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'regioninfo')"
                        v-bind:value="initvalue.regioninfo"
                        placeholder="Info Text"
                        persistent-hint
                        single-line hint="Enter the info text">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=items
                        :value="initvalue.regiontype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'regiontype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the region type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'regionstatus')"
                          v-bind:label="initvalue.regionstatus"
                          v-model="initvalue.regionstatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/region/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editRegion()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      region: {},
      detail: {},
      photo: {},
      pin: {
        error: false,
        error2: false
      },
      initvalue: {},
      items: ['Province', 'State', 'Division'],
      switch1: false,
      switch2: false,
    }
  },
  methods: {
    ...mapActions('Region', ['updateRegionRequest','getRegionsRequest']),
    editRegion() {
      this.region._id = this.initvalue._id;
      this.updateRegionRequest(this.region);
      this.getRegionsRequest();
      router.push('/region/list');
    },
    updateChangedValue(value, field){
      this.region[field] = value;
    },
  },
  computed: {
    ...mapState('Region', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'RegionList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
